import { useEffect } from "react";
import { useParams } from "react-router-dom";
import PartnerService from "services/partner.service";
import { partnerActions } from "redux/slices/partner";
import SelectRedux from "components/molecules/ComboBoxRedux";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import PrivilegeService from "utils/privilege.util";

export default function SelectSearchPartner(props: any) {
	const { id } = useParams();
	const dispatch = useAppDispatch();
	const partnerOptions = useAppSelector(
		(state) => state.partner.partnerOptions
	);
	const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);


	useEffect(() => {
		if (PrivilegeService.checkPrivilege("partner:read", permissions)) {
			PartnerService.getAllPartners();
		}

		return () => {
			dispatch(partnerActions.clear());
		};
	}, [dispatch]);

	return (
		<SelectRedux
			{...props}
			options={partnerOptions}
			disabled={id ? true : false}
		/>
	);
}
